import React from 'react';
import { X, Sparkles, ArrowUpRight, Check, Radio, Bot, Calendar } from 'lucide-react';

export default function LongXHubModal({ isOpen, onClose, onOpenHub, dontShowAgain, setDontShowAgain }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/75 backdrop-blur-sm p-4 animate-fade-in">
      <div 
        className="relative w-full max-w-lg rounded-2xl bg-[#0c1019] border border-white/10 shadow-2xl p-6 text-slate-100 space-y-5"
        role="dialog"
        aria-modal="true"
        aria-labelledby="hub-modal-title"
      >
        {/* Top Header */}
        <div className="flex items-center justify-between border-b border-white/10 pb-3">
          <h3 id="hub-modal-title" className="text-base sm:text-lg font-bold text-white tracking-wide">
            Chào mừng đến với giao diện mới Win AI Hub
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="px-2.5 py-1 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 text-xs font-mono text-slate-300 hover:text-white transition-all cursor-pointer flex items-center gap-1"
          >
            <span>Đóng</span>
            <X className="w-3.5 h-3.5" />
          </button>
        </div>

        {/* Description & Feature Highlights */}
        <div className="space-y-3.5 text-xs sm:text-sm text-slate-300 leading-relaxed font-sans">
          <p className="text-slate-200 font-medium">
            Win AI Hub là không gian làm việc mới, gọn hơn cho biểu đồ realtime, Bàn tín hiệu, Radar tin tức và Trợ lý phân tích.
          </p>

          <ul className="space-y-2.5 text-xs text-slate-300">
            <li className="flex items-start gap-2.5">
              <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 mt-1.5 flex-shrink-0" />
              <span>
                <strong className="text-white">Radar tin tức</strong> giúp gom tin liên quan đến symbol, dịch sang tiếng Việt và có nút giải thích tác động tin tức.
              </span>
            </li>
            <li className="flex items-start gap-2.5">
              <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 mt-1.5 flex-shrink-0" />
              <span>
                <strong className="text-white">Win AI Agent</strong> có thể trò chuyện trực tiếp theo chart hiện tại, hỗ trợ đọc setup, rủi ro và kịch bản giao dịch.
              </span>
            </li>
            <li className="flex items-start gap-2.5">
              <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 mt-1.5 flex-shrink-0" />
              <span>
                <strong className="text-white">Lịch kinh tế</strong> đang chuẩn bị cho tin CPI, FOMC và phân loại tin vàng/tin đỏ khi nguồn dữ liệu được mở lại.
              </span>
            </li>
          </ul>
        </div>

        {/* Footer Actions */}
        <div className="flex flex-wrap items-center justify-between gap-3 pt-3 border-t border-white/10 text-xs">
          <label className="flex items-center gap-2 cursor-pointer select-none text-slate-400 hover:text-slate-200">
            <input
              type="checkbox"
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
              className="w-4 h-4 rounded border-white/20 bg-slate-900 text-blue-500 focus:ring-0 cursor-pointer"
            />
            <span className="text-xs font-mono">Không hiển thị lại</span>
          </label>

          <div className="flex items-center gap-2 ml-auto">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 text-slate-300 hover:text-white font-mono font-medium transition-all cursor-pointer"
            >
              Để sau
            </button>
            <button
              type="button"
              onClick={() => {
                if (onOpenHub) onOpenHub();
                onClose();
              }}
              className="px-4 py-2 rounded-xl bg-gradient-to-r from-cyan-600 to-blue-500 hover:from-cyan-500 hover:to-blue-400 text-white font-bold font-mono transition-all shadow-[0_0_15px_rgba(0,242,254,0.4)] cursor-pointer flex items-center gap-1.5"
            >
              <span>Mở Win AI Hub</span>
              <ArrowUpRight className="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
